// =============== 🚀 ENHANCED CATEGORIES ===============
// AI-enhanced version of assessment categories with backward compatibility

import { ASSESSMENT_CATEGORIES } from './categories';
import { enhanceCategory, FEATURE_FLAGS } from '../../engine/enhancers/questionEnhancer';

// =============== ENHANCED CATEGORIES EXPORT ===============
export const ENHANCED_CATEGORIES = ASSESSMENT_CATEGORIES.map(category => 
  enhanceCategory(category)
);

// =============== CATEGORY SELECTOR ===============
// Returns enhanced or original categories based on feature flag
export const getActiveCategories = () => {
  return FEATURE_FLAGS.AI_SELECTION ? ENHANCED_CATEGORIES : ASSESSMENT_CATEGORIES;
};

// =============== QUESTION POOL STATS ===============
export const getQuestionPoolStats = () => {
  const activeCategories = getActiveCategories();
  
  return {
    totalCategories: activeCategories.length,
    totalBaseQuestions: activeCategories.reduce((sum, cat) => sum + cat.questions.length, 0),
    totalEnhancedPool: FEATURE_FLAGS.AI_SELECTION 
      ? activeCategories.reduce((sum, cat) => sum + (cat.totalQuestionPool || cat.questions.length), 0)
      : activeCategories.reduce((sum, cat) => sum + cat.questions.length, 0),
    aiEnabled: FEATURE_FLAGS.AI_SELECTION,
    enhancementVersion: FEATURE_FLAGS.AI_SELECTION ? '1.0' : 'disabled'
  };
};

// =============== CATEGORY UTILITIES ===============
export const getCategoryById = (categoryId) => {
  const activeCategories = getActiveCategories();
  return activeCategories.find(cat => cat.id === categoryId);
};

export const getQuestionById = (questionId) => {
  const activeCategories = getActiveCategories();
  
  for (const category of activeCategories) {
    const question = category.questions.find(q => q.id === questionId);
    if (question) return question;
    
    // Check follow-up questions if AI enabled
    if (FEATURE_FLAGS.AI_SELECTION) {
      for (const baseQuestion of category.questions) {
        if (baseQuestion.followUpTriggers) {
          const followUps = Object.values(baseQuestion.followUpTriggers);
          for (const followUp of followUps) {
            if (followUp.id === questionId) return followUp;
          }
        }
      }
    }
  }
  
  return null;
};

// =============== BACKWARD COMPATIBILITY ===============
// Export original categories for components that need them
export { ASSESSMENT_CATEGORIES as ORIGINAL_CATEGORIES } from './categories';

// Default export maintains compatibility
export default getActiveCategories();